import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'src/state/store';

export interface IAuthState {
  customerWebView?: boolean;
}

export const initialState: IAuthState = {
  customerWebView: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveGlobalAuthDelegateUser: (
      state,
      action: PayloadAction<{
        customerWebView: IAuthState['customerWebView'];
      }>,
    ) => {
      state.customerWebView = action.payload.customerWebView;
    },
  },
});

export const selectIsCustomerWebView = (state: RootState) =>
  state.authSlice.customerWebView;

export const { saveGlobalAuthDelegateUser } = authSlice.actions;

export default authSlice.reducer;
